import React from 'react'
import {SavStatutCode} from '../../../../components/sav/Models'
import {SAV_STATUTS} from '../../../../components/sav/libelles'

// Badge de statut d'un dossier SAV (maquette 0.7)
const SavStatutBadge = ({code}: {code: SavStatutCode}) => {
  const statut = SAV_STATUTS[code]
  return (
    <span className='badge fw-bold' style={{backgroundColor: statut?.fond, color: statut?.texte}}>
      {statut?.libelle ?? code}
    </span>
  )
}

export default SavStatutBadge
